<template>
  <div
    :class="[
      'table-container',
      {
        'logged-in': userTokenAvailable && !isMobile,
        'not-logged-in': !userTokenAvailable && isMobile,
      },
    ]"
  >
    <div class="hero-section">
      <div class="hero-background">
        <img
          class="banner-image-icon"
          alt="banner image"
          :src="getCDNlink('assets/new-assets/Institutes/Insititutes_Banner_Image.webp')"
        />
      </div>
      <div class="div">
        <div class="div-2">
          <div class="div-3">
            <div class="resources-badge">{{ $t("institutions") }}</div>
            <div class="empowering">
              {{ $t("institiutes-heading") }}
            </div>
            <div class="at-credence">
              {{ $t("institiutes-subheading") }}
            </div>
          </div>
          <div class="div-4">
            <div class="button" @click="navigateToFeatures">
              {{ $t("learnMore") }}
            </div>
            <div
              class="button-2"
              v-if="!userTokenAvailable"
              @click="this.$root.showLogin('SignUp')"
            >
              <span>{{ $t("sign-up") }}</span>
              <span class="icon" v-html="svgIcons.rightArrow"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WhyCredence />
    <WhoWeServeNew id="who-we-serve" />
    <section class="cta-section">
      <div
        class="card"
        :style="{
          backgroundImage: `url(${getCDNlink(
            'assets/new-assets/Transform-Card-BG.webp'
          )})`,
        }"
      >
        <div class="cta-container">
          <h2 class="cta-title">
            {{ $t("haveQuestions-heading") }}
          </h2>
          <div class="cta-buttons">
            <button
              class="cta-button primary"
              @click="this.$router.push('/contact')"
            >
              {{ $t("contact-us") }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="button-icon"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </button>
            <button class="cta-button secondary">
              {{ $t("subscribe") }}
            </button>
          </div>
        </div>
      </div>
    </section>
    <Footer class="footer-instance"></Footer>
    <div v-show="showScrollToTop" class="scroll-to-top" @click="scrollToTop">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0306 9.53073C16.9609 9.60046 16.8782 9.65578 16.7871 9.69352C16.6961 9.73127 16.5985 9.75069 16.4999 9.75069C16.4014 9.75069 16.3038 9.73127 16.2127 9.69352C16.1217 9.65578 16.039 9.60046 15.9693 9.53073L8.99993 2.56041L2.03055 9.53073C1.88982 9.67146 1.69895 9.75052 1.49993 9.75052C1.30091 9.75052 1.11003 9.67146 0.969304 9.53073C0.828573 9.39 0.749512 9.19912 0.749512 9.0001C0.749512 8.80108 0.828573 8.61021 0.969304 8.46948L8.4693 0.969476C8.53896 0.899744 8.62168 0.844425 8.71272 0.806682C8.80377 0.768939 8.90137 0.749512 8.99993 0.749512C9.09849 0.749512 9.19608 0.768939 9.28713 0.806682C9.37818 0.844425 9.4609 0.899744 9.53055 0.969476L17.0306 8.46948C17.1003 8.53913 17.1556 8.62185 17.1933 8.7129C17.2311 8.80395 17.2505 8.90154 17.2505 9.0001C17.2505 9.09866 17.2311 9.19626 17.1933 9.28731C17.1556 9.37836 17.1003 9.46107 17.0306 9.53073Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import WhyCredence from "@/components/Institutions/WhyCredence.vue";
import WhoWeServeNew from "@/components/Institutions/WhoWeServe/WhoWeServeNew.vue";
import VueCookies from "vue-cookies";
import Footer from "@/components/HomePage/Footer/Footer.vue";
import { svgIcons } from "@/assets/Icons/productsIcons.js";
import config from "@/config";

export default {
  name: "InstitutionsCorporate",
  components: {
    WhyCredence,
    WhoWeServeNew,
    Footer,
  },
  data() {
    return {
      userToken: null,
      isMobile: window.innerWidth < 1023,
      showScrollToTop: false,
      svgIcons,
    };
  },
  beforeMount() {
    this.userToken = VueCookies.get("token");
  },
  computed: {
    userTokenAvailable() {
      return this.userToken !== null;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
    navigateToFeatures() {
      this.$router.push({ path: "/product", hash: "#features-of-reports" });
    },
    navigateToLogin(actionType) {
      this.loginType = actionType;
      this.$router.push({ path: "/login", query: { type: actionType } });
    },
    scrollToWhoWeServe() {
      const section = document.getElementById("who-we-serve");
      if (section) {
        const offset = 25;
        const topPosition =
          section.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top: topPosition,
          behavior: "smooth",
        });
      }
    },
    redirectToContact() {
      this.$router.push("/contact");
    },
    handleScroll() {
      this.showScrollToTop = window.scrollY > 200;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped>
.hero-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
}

.banner-image-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  max-width: 50%;
  height: 100%;
  object-fit: cover;
  object-position: left center;
}

/* -------- */
.logged-in {
  margin-left: 18vw;
  padding-top: 55px !important;
}
.not-logged-in {
  width: 100%;
}
.table-container,
.table-container * {
  box-sizing: border-box;
}

.hero-section {
  position: relative;
  min-height: 80vh;
  display: flex;
  overflow: hidden;
  font-family: "Montserrat-Regular", sans-serif;
  background: radial-gradient(
    71.02% 71.03% at 16.95% 16.51%,
    #0f0d43 0%,
    #1d1016 100%
  );
  padding: 160px 0;
}

.div {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  margin: 0;
  padding: 0 160px;
  text-align: left;
}
.icon {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.div-3 {
  display: flex;
  width: 100%;
  max-width: 600px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  justify-content: center;
  gap: 16px;
}

.resources-badge {
  display: inline-block;
  padding: 12px 16px;
  color: #c94374;
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid #c94374;
  border-radius: 50px;
  margin-bottom: 1.2rem;
  width: fit-content;
  letter-spacing: 1px;
}
.at-credence {
  color: #fff;
  text-align: left;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  align-self: stretch;
}
.empowering {
  font-size: 46px;
  font-weight: 800;
  background: linear-gradient(135deg, #fff 0%, #ffece0 50%, #72b4ff 70%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  color: #fff;
}
.div-4 {
  display: flex;
  margin-top: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.18px;
}
.button {
  align-self: stretch;
  /* flex: 1; */
  border-radius: 13px;
  background-color: #0172f4;
  min-width: 150px;
  gap: 10px;
  color: #fff;
  margin: auto 0;
  padding: 16px 24px;
  cursor: pointer;
}
.button-2 {
  align-self: stretch;
  border-radius: 13px;
  background-color: #fd4c8c;
  min-width: 150px;
  color: #fff;
  margin: auto 0;
  padding: 14px 16px;
  cursor: pointer;
  border: 1px solid #fd4c8c;
  font-family: "Montserrat-Regular", sans-serif;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.18px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  white-space: nowrap;
  line-height: 1;
}

.button-2 .icon {
  width: auto;
  height: auto;
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
}

.scroll-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid white;
  background-color: #11365abd;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.18);
  border-radius: 50%;
  padding: 15px;
  cursor: pointer;
  z-index: 1000;
}
.scroll-to-top:hover {
  background-color: #11365a;
}
.scroll-to-top.show {
  display: block;
  gap: 20px;
}

.card {
  align-self: stretch;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px;
  gap: 30px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}

.cta-section {
  width: 100%;
  position: relative;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 80px;
  box-sizing: border-box;
  text-align: center;
  font-size: 48px;
  color: #fff;
  font-family: Figtree;
}

/* Light glow effect at the top */
.cta-section::before {
  content: "";
  position: absolute;
  top: -50%;
  left: 0;
  right: 0;
  height: 60%;
  background: radial-gradient(
    ellipse at center,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  pointer-events: none;
}

.cta-container {
  max-width: -webkit-fill-available;
  margin: 0;
  text-align: center;
  position: relative;
  z-index: 1;
}

.cta-title {
  color: #ffffff;
  font-size: 3rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
  line-height: 1.2;
}

.cta-subtitle {
  color: #ffffff;
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0 auto 2.5rem;
  max-width: 800px;
  opacity: 0.9;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 173px;
}

.cta-button.primary {
  background-color: #c94374;
  color: #ffffff;
}

.cta-button.primary:hover {
  background-color: #e43a7a;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(253, 76, 140, 0.3);
}

.cta-button.secondary {
  background-color: #046be1;
  color: #ffffff;
  opacity: 0.6 !important;
  cursor: not-allowed;
}

.cta-button.secondary:hover {
  background-color: #0160d0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(1, 114, 244, 0.3);
}

.button-icon {
  margin-left: 0.5rem;
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .cta-title {
    font-size: 2.5rem;
  }

  .cta-subtitle {
    font-size: 1.125rem;
  }
  .hero-section {
    min-height: auto;
    padding: 120px 0 60px;
  }

  .hero-background {
    position: relative;
    left: 0;
    height: 300px;
    margin-top: 40px;
  }

  .banner-image-icon {
    position: relative;
    max-width: 100%;
    height: 100%;
    transform: none;
    top: 0;
    left: 0;
  }

  .div {
    padding: 0 20px;
  }

  .div-3 {
    max-width: 100%;
  }
}

@media only screen and (max-width: 767px) {
  .cta-section {
    padding: 45px 40px;
  }

  .cta-title {
    font-size: 2rem;
  }

  .cta-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .hero-section {
    padding: 90px 0 40px;
  }
  .empowering {
    font-size: 24px;
  }
  .institutions {
    font-size: 16px;
  }
  .div {
    padding: 0;
  }
  .at-credence {
    font-size: 16px;
  }
  .button,
  .button-2 {
    font-size: 16px;
  }
  .button {
    padding: 14px 24px;
  }
  .button-2 {
    padding: 12px 24px;
  }
  .section-description {
    font-size: 16px;
  }
  .feature-title {
    font-size: 22px;
  }
  .feature-image {
    width: 50px;
    height: 50px;
  }
  .contact-button {
    padding: 10px 24px;
  }
  .query {
    padding: 40px 0px;
  }
}
@media (max-width: 480px) {
  .cta-section {
    padding: 25px;
    border-radius: 0.75rem;
  }

  .card {
    padding: 32px 10px;
  }

  .cta-title {
    font-size: 30px;
    margin-bottom: 1rem;
  }

  .cta-subtitle {
    font-size: 16px;
    margin-bottom: 1.75rem;
    line-height: 1.3;
  }

  .cta-button {
    padding: 0.75rem 1.5rem;
    font-size: 14px;
    font-weight: 400;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1156px) {
  .hero-section {
    padding: 100px 0;
  }

  .div {
    padding: 0 40px;
  }
  .empowering {
    font-size: 36px;
  }
  .at-credence {
    font-size: 18px;
  }
  .section-description {
    font-size: 16px;
  }
  .feature-title {
    font-size: 22px;
  }
  .feature-image {
    width: 50px;
    height: 50px;
  }
  .contact-button {
    padding: 10px 24px;
  }
}
@media only screen and (min-width: 1156px) {
}
</style>
